export let state = {
    connection: null,
    connectionId: null
};
